export enum EnergyTypes {
  DualFuel = 1,
  ElectricityOnly = 2,
  GasOnly = 3,
}
